import React from 'react';

import { CompanySubLogo } from '../CompanySubLogo/CompanySubLogo';
import { ReactComponent as LogoIcon } from '../../../assets/icons/logo.svg';
import { HeaderBar } from '../HeaderBar/HeaderBar';

type CompanyHeaderProps = { companyLogoUrl?: string };

const CompanyHeader = ({ companyLogoUrl }: CompanyHeaderProps) => {
  return (
    <HeaderBar toolbarComponent="div" inAngularContainer>
      {companyLogoUrl ? <CompanySubLogo logoUrl={companyLogoUrl} /> : <LogoIcon />}
    </HeaderBar>
  );
};

export { CompanyHeader };
